// Uppdatera variations-attribut (t.ex. Storlek) och custom variations-fält
// (Rotsystem, Antal per löpmeter) i Produktfakta när man byter variant.
//
// Attribut-värden renderas av servern i
// <span class="lw-variation-attr-value" data-attribute="attribute_pa_storlek">125-150 cm</span>.
// Custom-fält renderas i en egen <span> (se CUSTOM_FIELDS) och uppdateras via
// WC:s found_variation-event som ger oss variantens JSON-data.
;(function () {
    // key = nyckeln i variationens JSON (satt via woocommerce_available_variation),
    // selector = spanen som PHP renderar i Produktfakta-raden.
    const CUSTOM_FIELDS = [
        { key: 'rotsystem', selector: '.lw-rotsystem-value' },
        { key: 'rek_antal_per_lopmeter', selector: '.lw-rek-antal-value' },
    ]

    function updateProductFacts() {
        const form = document.querySelector('form.variations_form')
        if (!form) return

        document.querySelectorAll('.lw-variation-attr-value[data-attribute]').forEach((span) => {
            const select = form.querySelector(`select[name="${span.dataset.attribute}"]`)
            if (!select) return

            const opt = select.options[select.selectedIndex]
            if (opt && opt.value) {
                span.textContent = opt.text
            }
        })
    }

    // Sätter bara värdet. Om raden ska synas eller inte avgörs deklarativt av
    // CSS (:has(.lw-…-value:empty) i src/css/woocommerce/single-product.css),
    // så tom variant → dold rad utan att JS rör style.
    function updateCustomField(selector, value) {
        const span = document.querySelector(selector)
        if (!span) return
        span.textContent = value ? String(value).trim() : ''
    }

    function updateCustomFields(variation) {
        CUSTOM_FIELDS.forEach((field) => {
            updateCustomField(field.selector, variation && variation[field.key])
        })
    }

    // Vanilla change på variations-formulärets selects (täcker även .variation-button-UI:t
    // som dispatchar change på select).
    document.addEventListener('change', (e) => {
        if (e.target.matches && e.target.matches('form.variations_form select')) {
            updateProductFacts()
        }
    })

    // WC:s found_variation (jQuery) ger oss variantens kompletta JSON-data.
    // Behövs för custom-fält som inte finns i select-optionerna.
    if (window.jQuery) {
        window.jQuery(function ($) {
            $('form.variations_form').on('found_variation', function (event, variation) {
                updateProductFacts()
                updateCustomFields(variation)
            })
            $('form.variations_form').on('reset_data', function () {
                updateCustomFields(null)
            })
        })
    }

    document.addEventListener('DOMContentLoaded', updateProductFacts)
})()
